import { render, staticRenderFns } from "./HeaderTrial.vue?vue&type=template&id=2e60f087&scoped=true&"
import script from "./HeaderTrial.vue?vue&type=script&lang=js&"
export * from "./HeaderTrial.vue?vue&type=script&lang=js&"
import style0 from "./HeaderTrial.vue?vue&type=style&index=0&id=2e60f087&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e60f087",
  null
  
)

export default component.exports